// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BnZJ","comment":"styles_comment__1zU-h"};